var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 501.715,
    x2: 254.8091,
    y2: 393.293,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M355.982,111.859c-5.256,0-9.515-4.26-9.515-9.515V72.213 c0-29.326-23.857-53.183-53.183-53.183h-74.566c-29.326,0-53.183,23.857-53.183,53.183v30.131c0,5.256-4.26,9.515-9.515,9.515 c-5.256,0-9.515-4.26-9.515-9.515V72.213C146.504,32.396,178.899,0,218.717,0h74.566c39.819,0,72.213,32.396,72.213,72.213v30.131 C365.497,107.599,361.238,111.859,355.982,111.859z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8081,
    y1: 446.873,
    x2: 254.8081,
    y2: 297.493,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M437.933,55.933l-0.481,0.235c-16.273,7.941-35.315,7.85-51.51-0.248 c-16.404-8.005-35.575-8.005-51.966,0l-0.013,0.013c-16.404,8.005-35.575,8.005-51.979,0l-0.013-0.013 c-16.392-8.005-35.562-8.005-51.966,0l-0.013,0.013c-16.392,8.005-35.575,8.005-51.966,0h-0.013 c-8.196-4.009-17.09-6.013-25.983-6.013c-8.987,0-17.975,2.047-26.256,6.141c-16.266,8.042-35.4,7.831-51.707-0.127l0,0 c-12.004-5.859-25.996,2.882-25.996,16.239v311.045c0,21.468,17.403,38.87,38.87,38.87h338.117c21.468,0,38.87-17.403,38.87-38.87 V72.173C463.929,58.816,449.937,50.075,437.933,55.933z M156.715,117.937c-7.639,0-13.831-6.192-13.831-13.831 s6.192-13.831,13.831-13.831c7.639,0,13.831,6.192,13.831,13.831C170.546,111.745,164.354,117.937,156.715,117.937z  M355.286,117.937c-7.639,0-13.831-6.192-13.831-13.831s6.192-13.831,13.831-13.831s13.831,6.192,13.831,13.831 C369.117,111.745,362.925,117.937,355.286,117.937z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.7391,
    y1: 189.9028,
    x2: 559.5391,
    y2: 189.9028,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M437.933,145.845l-0.481,0.235c-16.273,7.941-35.315,7.85-51.51-0.248 c-16.404-8.005-35.575-8.005-51.966,0l-0.013,0.013c-16.404,8.005-35.575,8.005-51.979,0l-0.013-0.013 c-16.392-8.005-35.562-8.005-51.966,0l-0.013,0.013c-16.392,8.005-35.575,8.005-51.966,0h-0.013 c-8.196-4.009-17.09-6.014-25.983-6.014c-8.987,0-17.975,2.047-26.256,6.141c-16.266,8.042-35.4,7.831-51.707-0.127l0,0 c-12.004-5.859-25.996,2.882-25.996,16.239v311.045c0,21.468,17.403,38.87,38.87,38.87h338.117c21.468,0,38.87-17.403,38.87-38.87 V162.084C463.929,148.727,449.937,139.986,437.933,145.845z M156.715,207.848c-7.639,0-13.831-6.192-13.831-13.831 c0-7.639,6.192-13.831,13.831-13.831c7.639,0,13.831,6.192,13.831,13.831C170.546,201.656,164.354,207.848,156.715,207.848z  M355.286,207.848c-7.639,0-13.831-6.192-13.831-13.831c0-7.639,6.192-13.831,13.831-13.831s13.831,6.192,13.831,13.831 C369.117,201.656,362.925,207.848,355.286,207.848z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.1688,
    y1: 73.8427,
    x2: 85.2088,
    y2: 434.7927,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M463.929,473.13V289.661l-94.852-94.852c-0.414,7.267-6.42,13.038-13.791,13.038 c-3.353,0-6.426-1.194-8.82-3.178v59.502c0,29.122-13.846,55.056-35.285,71.614l-140.799-139.75 c-0.979,6.679-6.716,11.812-13.667,11.812c-4.05,0-7.681-1.751-10.211-4.525v60.848c0,31.533,13.416,59.977,34.819,79.974 L349.177,512h75.881C446.526,512,463.929,494.597,463.929,473.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 330.703,
    x2: 254.8091,
    y2: 142.336,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M256.001,373.667c-60.377,0-109.497-49.119-109.497-109.496v-70.095 c0-5.256,4.26-9.515,9.515-9.515s9.515,4.26,9.515,9.515v70.095c0,49.882,40.583,90.464,90.466,90.464s90.466-40.583,90.466-90.464 v-70.095c0-5.256,4.26-9.515,9.515-9.515s9.515,4.26,9.515,9.515v70.095C365.497,324.548,316.377,373.667,256.001,373.667z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.8979,
    y1: 114.3306,
    x2: -9.462,
    y2: 28.0407,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M48.072,369.031v104.099c0,21.468,17.403,38.87,38.87,38.87h338.117 c21.468,0,38.87-17.403,38.87-38.87V369.031H48.072z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingBag);
export default __webpack_public_path__ + "static/media/icon-shopping-bag.ba5c50cf3e37d7cde2d31692e37457eb.svg";
export { ForwardRef as ReactComponent };